import { GRID_SIZE } from "./constants.js";
function countBlocks(grid) {
  var _a;
  let count = 0;
  for (let r = 0; r < GRID_SIZE; r++) {
    for (let c = 0; c < GRID_SIZE; c++) {
      if (((_a = grid[r]) == null ? void 0 : _a[c]) === 1) count++;
    }
  }
  return count;
}
const teleportModule = {
  id: "teleport",
  name: "텔레포트",
  description: "블록을 텔레포트하여 형태를 변환하는 방법을 배웁니다",
  problem: { left: 3, right: 4 },
  steps: [
    {
      id: "tp-1",
      instruction: '"가로 → 5" 텔레포트 버튼을 눌러 블록을 가로 5줄로 변형하세요',
      hint: '왼쪽 텔레포트 영역의 "가로 → 5" 버튼을 클릭하세요',
      highlightArea: { type: "control", buttonId: "teleport-row-5" },
      validate: (state) => {
        var _a, _b;
        for (let r = 0; r < GRID_SIZE; r++) {
          let consecutive = 0;
          for (let c = 0; c < GRID_SIZE; c++) {
            if (((_a = state.grid[r]) == null ? void 0 : _a[c]) === 1) consecutive++;
            else consecutive = 0;
          }
          if (consecutive === 5) return true;
        }
        let minC = GRID_SIZE, maxC = -1;
        for (let r = 0; r < GRID_SIZE; r++) {
          for (let c = 0; c < GRID_SIZE; c++) {
            if (((_b = state.grid[r]) == null ? void 0 : _b[c]) === 1) {
              if (c < minC) minC = c;
              if (c > maxC) maxC = c;
            }
          }
        }
        return maxC - minC + 1 === 5;
      }
    },
    {
      id: "tp-2",
      instruction: '이제 "세로 ↓ 10" 텔레포트로 세로 10줄 형태로 변형하세요',
      hint: '"세로 ↓ 10" 버튼을 클릭하세요',
      highlightArea: { type: "control", buttonId: "teleport-col-10" },
      validate: (state) => {
        var _a;
        let minR = GRID_SIZE, maxR = -1;
        for (let r = 0; r < GRID_SIZE; r++) {
          for (let c = 0; c < GRID_SIZE; c++) {
            if (((_a = state.grid[r]) == null ? void 0 : _a[c]) === 1) {
              if (r < minR) minR = r;
              if (r > maxR) maxR = r;
            }
          }
        }
        return maxR - minR + 1 === 10;
      }
    }
  ]
};
const removeModule = {
  id: "remove",
  name: "블록 제거",
  description: "10개 블록 패턴을 찾아 제거하는 방법을 배웁니다",
  problem: { left: 4, right: 5 },
  steps: [
    {
      id: "rm-1",
      instruction: '"가뚱 2×5" 버튼을 눌러 2×5 패턴의 블록 10개를 제거하세요',
      hint: '왼쪽 블록 제거 영역의 "가뚱 2×5" 버튼을 클릭하세요',
      highlightArea: { type: "control", buttonId: "remove-가뚱" },
      validate: (state) => state.removedBlocks >= 10
    },
    {
      id: "rm-2",
      instruction: '한 번 더! "가뚱 2×5" 버튼으로 10개를 더 제거하세요',
      hint: "같은 버튼을 다시 클릭하세요",
      highlightArea: { type: "control", buttonId: "remove-가뚱" },
      validate: (state) => state.removedBlocks >= 20
    }
  ]
};
const rearrangeModule = {
  id: "rearrange",
  name: "재정리",
  description: "흩어진 블록을 정리하는 방법을 배웁니다",
  problem: { left: 3, right: 7 },
  steps: [
    {
      id: "rr-1",
      instruction: '먼저 "가뚱 2×5"로 블록 10개를 제거하세요',
      hint: '"가뚱 2×5" 버튼을 클릭하세요',
      highlightArea: { type: "control", buttonId: "remove-가뚱" },
      validate: (state) => state.removedBlocks >= 10
    },
    {
      id: "rr-2",
      instruction: '블록이 흩어졌습니다. "재정리" 버튼으로 블록을 깔끔하게 정리하세요',
      hint: '하단의 "재정리" 버튼을 클릭하세요',
      highlightArea: { type: "toolbar", buttonId: "rearrange" },
      validate: (state) => {
        var _a;
        let minR = GRID_SIZE, maxR = -1, minC = GRID_SIZE, maxC = -1;
        const total = countBlocks(state.grid);
        for (let r = 0; r < GRID_SIZE; r++) {
          for (let c = 0; c < GRID_SIZE; c++) {
            if (((_a = state.grid[r]) == null ? void 0 : _a[c]) === 1) {
              if (r < minR) minR = r;
              if (r > maxR) maxR = r;
              if (c < minC) minC = c;
              if (c > maxC) maxC = c;
            }
          }
        }
        if (total === 0) return false;
        return minR === 0 && minC === 0 && total <= (maxR + 1) * (maxC + 1);
      }
    }
  ]
};
const solveModule = {
  id: "solve",
  name: "종합 풀기",
  description: "텔레포트와 제거를 조합하여 문제를 풀어봅니다",
  problem: { left: 3, right: 5 },
  steps: [
    {
      id: "sv-1",
      instruction: "3 × 5 = 15입니다. 블록을 텔레포트하여 제거 가능한 형태로 만드세요",
      hint: '"가로 → 5" 텔레포트 버튼을 사용해보세요',
      highlightArea: { type: "control", buttonId: "teleport-row-5" },
      validate: (state) => {
        var _a;
        let minC = GRID_SIZE, maxC = -1;
        for (let r = 0; r < GRID_SIZE; r++) {
          for (let c = 0; c < GRID_SIZE; c++) {
            if (((_a = state.grid[r]) == null ? void 0 : _a[c]) === 1) {
              if (c < minC) minC = c;
              if (c > maxC) maxC = c;
            }
          }
        }
        return maxC - minC + 1 === 5;
      }
    },
    {
      id: "sv-2",
      instruction: '"가뚱 2×5" 버튼으로 블록 10개를 제거하세요',
      hint: '"가뚱 2×5" 버튼을 클릭하세요',
      highlightArea: { type: "control", buttonId: "remove-가뚱" },
      validate: (state) => state.removedBlocks >= 10
    },
    {
      id: "sv-3",
      instruction: "남은 블록이 5개입니다. 더 이상 제거할 패턴이 없으면 자동 완료됩니다!",
      hint: "남은 블록 5개 = 나머지. 자동으로 완료됩니다",
      validate: (state) => state.isComplete
    }
  ]
};
const MODULE_REGISTRY = {
  teleport: teleportModule,
  remove: removeModule,
  rearrange: rearrangeModule,
  solve: solveModule
};
Object.values(MODULE_REGISTRY).map((m) => ({ id: m.id, name: m.name, description: m.description }));
//# sourceMappingURL=tutorial.js.map
